import BaseFormatterCreator from './BaseFormatterCreator'

export default class PDFFormatterCreator extends BaseFormatterCreator
{
   getCategoryToStringFunction(selectedCategoryType, chartType) {
       const categoryToStringFn = super.getCategoryToStringFunction(selectedCategoryType)
        return (category, maxLens) => {
            let formattedCategory = categoryToStringFn(category)
            if (formattedCategory.length > maxLens) {
                formattedCategory = formattedCategory.substr(0, maxLens - 1) + '...'; // cut characters and add ellipsis
            }
            return formattedCategory;
        }
    };
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/PDFFormatterCreator.js